import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

import { filterLabelOverrides } from '@/constants/filterData';

@Pipe({
  standalone: true,
  name: 'filterLabel',
  pure: true,
})
export class FilterLabelPipe implements PipeTransform {

  private titleCasePipe = new TitleCasePipe();

  transform(value: string): string {
    if (!value) return '';

    if (filterLabelOverrides[value]) {
      return filterLabelOverrides[value];
    }

    return this.titleCasePipe.transform(value.replace(/-/g, ' '));
  }
}
